import React, { useState } from "react";
import axios from "axios";
import { Snowflake } from "lucide-react";
import { useLang } from "../store";
import { useT } from "../i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Footer() {
  const { lang } = useLang();
  const t = useT(lang);
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) return;
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      setDone(true);
      setEmail("");
    } catch (err) {
      console.error("Newsletter signup failed:", err);
    }
    setLoading(false);
  };

  return (
    <footer className="bg-[#0C0A09] text-white">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-16">
        {/* Newsletter */}
        <div className="bg-[#9BE800] text-[#0C0A09] border-[3px] border-white p-7 md:p-10 mb-12 grid grid-cols-1 md:grid-cols-12 gap-6 items-center">
          <div className="md:col-span-7">
            <h3 className="font-display text-4xl md:text-5xl leading-none">{t.footer.newsletter}</h3>
            <p className="mt-2 font-medium">{t.footer.newsletterSub}</p>
          </div>
          <form onSubmit={submit} className="md:col-span-5 flex gap-2">
            <input
              data-testid="newsletter-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t.footer.emailPlaceholder}
              className="flex-1 bg-white border-[3px] border-[#0C0A09] px-4 py-3 font-bold focus:outline-none"
            />
            <button data-testid="newsletter-submit-btn" type="submit" disabled={loading} className="nb-btn ink !rounded-none">
              {loading ? "..." : t.footer.subscribe}
            </button>
          </form>
          {done && <div data-testid="newsletter-success" className="md:col-span-12 text-sm font-bold uppercase tracking-widest">★ {t.footer.subscribed}</div>}
        </div>

        {/* Footer body */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-9 h-9 rounded-full bg-[#FF3D7F] border-[3px] border-white flex items-center justify-center">
                <Snowflake size={18} strokeWidth={3} />
              </div>
              <span className="font-display text-3xl tracking-tight">VELORA</span>
            </div>
            <p className="text-sm opacity-80 max-w-xs">{t.footer.tagline}</p>
          </div>
          <div>
            <div className="font-display text-2xl mb-3 text-[#9BE800]">{t.footer.shop}</div>
            <ul className="space-y-2 text-sm">
              <li><a href="#shop" className="hover:underline">{t.footer.shop}</a></li>
              <li><a href="#how" className="hover:underline">{t.nav.how}</a></li>
              <li><a href="#reviews" className="hover:underline">{t.nav.reviews}</a></li>
            </ul>
          </div>
          <div>
            <div className="font-display text-2xl mb-3 text-[#9BE800]">{t.footer.help}</div>
            <ul className="space-y-2 text-sm">
              <li><a href="#faq" className="hover:underline">{t.footer.faq}</a></li>
              <li><a href="#" className="hover:underline">{t.footer.shipping}</a></li>
              <li><a href="#" className="hover:underline">{t.footer.returns}</a></li>
              <li><a href="mailto:hello@velora.shop" className="hover:underline">{t.footer.contact}</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/20 text-xs opacity-70">{t.footer.rights}</div>
      </div>
    </footer>
  );
}
